module.exports = __webpack_public_path__ + "img/12217_8.ddae0db7.png";